module.exports = __webpack_public_path__ + "static/siEn-429f9e602a4b43fd2e67ce9f5efd1af0.jpg";